import { render, staticRenderFns } from "./SliderComponentEdges.vue?vue&type=template&id=8d710ad2&scoped=true"
import script from "./SliderComponentEdges.vue?vue&type=script&lang=js"
export * from "./SliderComponentEdges.vue?vue&type=script&lang=js"
import style0 from "./SliderComponentEdges.vue?vue&type=style&index=0&id=8d710ad2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d710ad2",
  null
  
)

export default component.exports